import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getDepartments as onGetDepartments,
    addNewDepartment as onAddNewDepartment,
    updateDepartment as onUpdateDepartment,
    deleteDepartment as onDeleteDepartment,

    getFaculties as onGetFaculties,

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Department = () => {

    //meta title
    document.title = "Affectations professeurs | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [department, setDepartment] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            id: (department && department.id) || '',
            uid: (department && department.uid) || '',
            name: (department && department.name) || '',
            code: (department && department.code) || '',
            faculty_id: (department && department.faculty_id) || '',
            description: (department && department.description) || '',
            is_active: (department && department.is_active) || '',
            
        },
        validationSchema: Yup.object({
           
            name: Yup.string().required("Veuillez saisir le nom"),
            code: Yup.string().required("Veuillez saisir le code"),
            faculty_id: Yup.string().required("Veuillez sélectionner la faculté"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateDepartment = {
                    id: values.id,
                    uid: values.uid,
                    name: values.name,
                    code: values.code,
                    faculty_id: values.faculty_id,
                    description: values.description,
                    is_active: values.is_active,
                    
                };
                // update movie category
                dispatch(onUpdateDepartment(updateDepartment));
                validation.resetForm();
            } else {
                const newDepartment = {
                    //id: values["id"],
                    //uid: values["uid"],
                    name: values["name"],
                    code: values["code"],
                    faculty_id: values["faculty_id"],
                    description: values["description"],
                    is_active: values["is_active"],
                   
                };
                // save new movie category
                dispatch(onAddNewDepartment(newDepartment));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const DepartmentProperties = createSelector(
        (state) => state.departmentReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (departmentReducer) => ({
            departments: departmentReducer.departments,
            loading: departmentReducer.loading
        })
    );

    const {departments, loading} = useSelector(DepartmentProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {

        
        if (departments && !departments.length) {
            console.log("ON L")
            dispatch(onGetDepartments());
        }
    }, [dispatch, departments]);


    // Faculties
        const FacultyProperties = createSelector(
            (state) => state.facultyReducer, 
            (facultyReducer) => ({
                faculties: facultyReducer.faculties,
                loading: facultyReducer.loading
            })
        );
    
        const {faculties} = useSelector(FacultyProperties);
    
    
        
    
        useEffect(() => {
            if (faculties && !faculties.length) {
                dispatch(onGetFaculties());
            }
        }, [dispatch, faculties]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setDepartment(null);
        } else {
            setModal(true);
        }
    };

    const handleDepartmentClick = arg => {
        const department = arg;
        setDepartment({
            id: department.id,
            uid: department.uid,
            name: department.name,
            code: department.code,
            faculty_id: department.faculty_id,
            description: department.description,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setDepartment(branch);
        setDeleteModal(true);
    };

    const handleDeleteDepartment = () => {
        if (department && department.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteDepartment(department));
            setDeleteModal(false);
        }
    };

    const onClickNewDepartment = () => {
        setIsEdit(false);
        setDepartment(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Professeur",
                accessorKey: "teacher.full_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Faculté",
                accessorKey: "faculty.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Département",
                accessorKey: "department.name",
                enableColumnFilter: false,
                enableSorting: true,

                header: "Type",
                accessorKey: "affectation_type",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleDepartmentClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteDepartment}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Affectations professeurs" breadcrumbItem="Liste des affectations professeurs" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewDepartment} className="btn btn-primary me-1">Ajouter une affectation</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={departments || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Affectation professeur" : "Ajouter - Affectation professeur"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        
                                        <div className="mb-3">
                                            <Label>Professeur</Label>
                                            <Input
                                                name="faculty_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.faculty_id || ""
                                                }
                                                invalid={
                                                    validation.touched.faculty_id && validation.errors.faculty_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {faculties.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.faculty_id && validation.errors.faculty_id ? (
                                                <FormFeedback type="invalid">{validation.errors.faculty_id}</FormFeedback>
                                            ) : null}
                                        </div>
                                       

                                        <div className="mb-3">
                                            <Label>Faculté</Label>
                                            <Input
                                                name="faculty_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.faculty_id || ""
                                                }
                                                invalid={
                                                    validation.touched.faculty_id && validation.errors.faculty_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {faculties.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.faculty_id && validation.errors.faculty_id ? (
                                                <FormFeedback type="invalid">{validation.errors.faculty_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Département</Label>
                                            <Input
                                                name="department_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.department_id || ""
                                                }
                                                invalid={
                                                    validation.touched.faculty_id && validation.errors.faculty_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {faculties.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.faculty_id && validation.errors.faculty_id ? (
                                                <FormFeedback type="invalid">{validation.errors.faculty_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Date début</Label>
                                            <Input
                                                name="start_date"
                                                placeholder="Heure début"
                                                type="time"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.start_time || ""}
                                                invalid={
                                                    validation.touched.start_time && validation.errors.start_time ? true : false
                                                }
                                            />
                                            {validation.touched.start_time && validation.errors.start_time ? (
                                                <FormFeedback type="invalid">{validation.errors.start_time}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Date fin</Label>
                                            <Input
                                                name="start_date"
                                                placeholder="Heure début"
                                                type="time"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.start_time || ""}
                                                invalid={
                                                    validation.touched.start_time && validation.errors.start_time ? true : false
                                                }
                                            />
                                            {validation.touched.start_time && validation.errors.start_time ? (
                                                <FormFeedback type="invalid">{validation.errors.start_time}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Type</Label>
                                            <Input
                                                name="semester"
                                                type="select"
                                                value={validation.values.semester || ""}
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                invalid={
                                                    validation.touched.semester && validation.errors.semester ? true : false
                                                }
                                                >
                                                <option value="">Sélectionner</option>
                                                <option value="S1">Permanent</option>
                                                <option value="S2">Vacataire</option>
                                                
                                            </Input>
                                            {validation.touched.semester && validation.errors.semester ? (
                                                <FormFeedback type="invalid">{validation.errors.semester}</FormFeedback>
                                            ) : null}
                                        </div>

                                       

                                        
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Department;